import React, { useState } from 'react';
import Modal from 'react-modal';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#f9f9f9',
        padding: '24px'
    },
    overlay: {
        background: "#00000080"
    }
};

const ActionModal =({ isOpen, onClose, onConfirm, action, actionId})=>{
    const [remark, setRemark] = useState('');
    const onRemarkChange = (v) =>{
        setRemark(v)
    }
    // const onConfirm = () =>{
    //     loading(true);
    //     //this.props.setLoading(true);
    // }
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={customStyles}>
                <div className="flex-v">
                    <div className="is-size-5 text-center has-text-grey-dark mb-24">{`Do you want to ${action} the request?`}</div>
                    <div className="is-size-6 has-text-grey mb-24">
                        <textarea className="textarea is-small" value={remark} placeholder={`Reason for ${action}.`} onChange={e => onRemarkChange(e.target.value)} />
                    </div>
                    <div className="flex-h flex-between">
                        <button onClick={() => onConfirm(remark)} className={`button is-success is-fullwidth is-rounded mt-16 mb-16 mr-16`}>Confirm</button>
                        <button onClick={() => onClose()} className={`button is-danger is-fullwidth is-rounded mt-16 mb-16 ml-16`}>Cancel</button>
                    </div>
                </div>
        </Modal>
    );
}
export default ActionModal;